<template>
  <a-card :bordered="false">
    <div style="text-align: right">
      <a-button style="" type="link" @click="add" v-has="'COMPANY_ADD'">
        添加
      </a-button>
      <a-dropdown trigger="click" v-has="'COMPANY_UP'">
        <span class="el-dropdown-link">
          <a-button type="link" icon="el-icon-upload2">导入导出</a-button>
        </span>
        <a-menu slot="overlay">
          <a-menu-item icon="el-icon-upload">
            <a-upload
              action="/api/import-area"
              @change="handleSuccess"
              :before-upload="beforeAvatarUpload"
              :showUploadList=false>
              <span>上传文件</span>
            </a-upload>
          </a-menu-item>
          <a-menu-item icon="el-icon-download" @click="exportExcel">下载文件
          </a-menu-item>
          <a-menu-item icon="el-icon-document-copy" @click="downloadExcel">下载模板
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <a-table
      :loading="table.loading"
      :data-source="table.data"
      :pagination="false"
      ref="table.dataRef"
      :scroll="{ x: 2160 }">>
      <!--      <el-table-column type="index" label="No." width="100" align="center" fixed>-->
      <!--      </el-table-column>-->
      <a-table-column
        key="name"
        align="center"
        data-index="name" title="区域名称" width="120" fixed="left">
      </a-table-column>
      <a-table-column
        align="center"
        key="012"
        data-index="012" title="韵达-YD" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="013"
        data-index="013" title="申通-STO" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="123"
        data-index="123" title="德邦-DBL" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="234"
        data-index="234" title="跨越-KYSY" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="256"
        data-index="256" title="圆通-YTO" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="345"
        data-index="345" title="全一-UAPEX" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="456"
        data-index="456" title="速尔-SURE" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="567"
        data-index="567" title="顺丰-SF" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="568"
        data-index="568" title="顺丰当天件-SF" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="569"
        data-index="569" title="顺丰当天件-NSF" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="570"
        data-index="570" title="顺丰当天件-SFGJ" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="789"
        data-index="789" title="顺丰-NSF" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="890"
        data-index="890" title="顺丰-SFGJ" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="901"
        data-index="901" title="韵达快运-YDKY" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="902"
        data-index="902" title="德邦零担-DBL" width="120">
      </a-table-column>
      <a-table-column
        align="center"
        key="1000"
        data-index="1000" title="自运输" width="120">
      </a-table-column>
      <a-table-column title="操作" width="120" fixed="right" align="center">
        <template slot-scope="text, record">
          <a-button @click="edit(record)" v-has="'AREA_EDIT'" type="link" size="small">编辑</a-button>
          <a-divider type="vertical"/>
          <a-button @click="del(record)" v-has="'AREA_DELETE'" type="link" size="small"
                    class="operationBtn">删除
          </a-button>
        </template>
      </a-table-column>
    </a-table>

    <a-modal v-model="form.visible" width="600px" :destroy-on-close="true" @cancel="onFormCancel" @ok="onFormSave">
      <area-edit :get-list="getList" :area-id="form.data.areaName"  ref="areaEditRef"></area-edit>
    </a-modal>

    <!--    </div>-->
  </a-card>
</template>

<script>
import {delArea, getAreaList,} from '../../../api/area';
import AreaEdit from './AreaEdit.vue';
import {getTime} from '../../../utils/dateUtil';

/**
 * 初始化用户列表数据
 */
async function getList() {
  // this.table.data = [];
  // this.$set(this.table,'data',[])
  const result = await getAreaList();
  if (result.code === 1200) {
    this.$set(this.table, "data", result.data.areas)
    // this.table.data = result.data.areas;
  }
}

async function onFormSave() {
  this.form.visible = false;
  await this.$refs.areaEditRef.save();
  // this.getList();
  this.form.data = {};
}


function onFormCancel() {
  this.form.visible = false;
  // this.getList();
  this.form.data = {};
}

function edit(record) {
  this.form.data.areaName = record.name;
  this.form.visible = true;
}

function add() {
  this.form.data.areaName = '';
  this.form.visible = true;
}

async function del(record) {
  let that = this;
  this.$confirm({
    title: '是否删除这条数据?',
    content: '',
    // okType: 'danger',
    async onOk() {
      const result = await delArea(record.name);
      if (result.code === 1200) {
        that.$message.success('删除成功')
        that.form.data = {};
        await that.getList();
      }
    },
    //   this.onCancel()
    onCancel() {
    },
    class:
      'test',
  });
}

function exportExcel() {
  require.ensure([], () => {
    const { export_json_to_excel } = require('../../../utils/Export2Excel');
    const tHeader = ['区域名称', '快递韵达-YD', '快递-申通-STO', '快递-德邦-DBL', '汽运-跨越-KYSY', '快递-圆通-YTO',
      '快递-全一-UAPEX', '快递-速尔-SURE', '快递-顺丰-SF', '快递-顺丰当天件-SF', '快递-顺丰当天件-NSF', '快递-顺丰当天件-SFGJ',
      '快递-顺丰-NSF', '快递-顺丰-SFGJ', '快递-韵达快运-YDKY', '汽运-德邦零担-DBL', '自运输-ZYX'];
    // 上面设置Excel的表格第一行的标题
    const filterVal = ['name', '012', '013', '123', '234', '256', '345', '456', '567', '568', '569', '570', '789', '890', '901', '902', '1000'];
    // 上面的index、nickName、name是tableData里对象的属性
    const list = this.table.data; // 把data里的tableData存到list
    const data = this.formatJson(filterVal, list);
    export_json_to_excel(tHeader, data, `区域配置导出${ getTime() }`);
  });
}

/**
 * 文件上传之前的回调函数
 */
// eslint-disable-next-line consistent-return
function beforeAvatarUpload(file) {
//        判断上传文件的后缀 是否为 xls 或 xlsx 格式
  const index = file.name.lastIndexOf('.');
  const fileName = file.name.substring(index + 1);
  if (fileName !== 'xls' && fileName !== 'xlsx') {
    let that = this;
    this.$confirm({
      title: '上传文件必须为 .xls 或 .xlsx 格式 ?',
      content: '',
      okType: 'warning',
      onOk() {
        that.form.dialogVisibleWorker = false;
      },
      //   this.onCancel()
      onCancel() {
        that.form.dialogVisibleWorker = false;
      },
      class:
        'test',
    });
    // this.$confirm('上传文件必须为 .xls 或 .xlsx 格式 ', '提示', {
    //   confirmButtonText: '确定',
    //   cancelButtonText: '取消',
    //   type: 'warning',
    // }).catch(() => {
    //   //                关闭批量上传弹窗
    //   this.form.dialogVisibleWorker = false;
    // });
    return false;
  }
}

function handleSuccess(res) {
  let that = this;
  // setTimeout(() => {
    if (this.uploadTrue) {
      if (res.file.response && res.file.response.code === 1200) {
        that.$message.success('上传成功');
        this.getList();
      }
    } else {
      this.uploadTrue = !this.uploadTrue
    }
  // }, 1000)
}

function formatJson(filterVal, jsonData) {
  return jsonData.map(v => filterVal.map(j => v[j]));
}

async function downloadExcel() {
  let that = this;
  let model = this.$confirm({
    title: '是否下载区域配置导入模板.xlsx？',
    content: '',
    // okType: 'danger',
    onOk() {
      window.location.href = '/api/signForImg/区域配置导入模板.xlsx';
    },
    onCancel() {
    },
    class: 'test',
  });
}

export default {
  components: {
    AreaEdit,
  },
  methods: {
    getList,
    onFormSave,
    onFormCancel,
    edit,
    add,
    del,
    exportExcel,
    formatJson,
    beforeAvatarUpload,
    handleSuccess,
    downloadExcel,
  },
  created() {
    this.getList();
  },
  data() {
    return {
      uploadTrue: true,
      table: {
        loading: false,
        data: [],
      },
      form: {
        visible: false,
        data: {
          areaName: '',
        },
      },
    };
  },
};
</script>

<style>
  .el-table .cell.el-tooltip {
    white-space: pre-wrap;
  }
</style>
